<template>
    <div class="ma-3">
        <div class="title mb-3">
            Capacity exceptions management <v-icon>mdi-chevron-right</v-icon> {{ isNew ? 'New' : 'Edit' }}
        </div>

        <v-form ref="form" v-model="formValid" layout="column" layout-align="center center" @submit.prevent="save(false)">
            <div class="field-width">
                <div class="title font-weight-light mb-3">
                    Capacity exception information
                </div>
                <div layout="row" layout-align="start center">
                    <date-field v-model="exception.start" label="Start date" required :form="$refs.form"
                        class="field-width" />
                </div>
                <div layout="row" layout-align="start center" class="my-3">
                    <date-field v-model="exception.end" label="End date" required :form="$refs.form"
                        class="field-width" />
                </div>

                <v-text-field v-model="exception.max_morning" type="number" outline label="Morning max capacity"
                    class="field-width" :rules="[
                        v => /^[0-9]+$/.test(v) || 'This field must be a number',
                        v => (!!v && v >= 0) || 'This field is required'
                    ]" />
                <v-text-field v-model="exception.max_afternoon" type="number" outline label="Afternoon max capacity"
                    class="field-width" :rules="[
                        v => /^[0-9]+$/.test(v) || 'This field must be a number',
                        v => (!!v && v >= 0) || 'This field is required'
                    ]" />
                <v-text-field v-model="exception.max_evening" type="number" outline label="Evening max capacity"
                    class="field-width" :rules="[
                        v => /^[0-9]+$/.test(v) || 'This field must be a number',
                        v => (!!v && v >= 0) || 'This field is required'
                    ]" />
            </div>

            <div layout="row" layout-align="end center" class="field-width">
                <v-btn depressed color="primary" @click="save(false)">
                    Save
                </v-btn>
                <span class="mx-1">or</span>
                <template v-if="isNew">
                    <v-btn depressed outline color="primary" @click="save(true)">
                        Save and continue
                    </v-btn>
                    <span class="mx-1">or</span>
                </template>
                <router-link :to="{ name: 'admin-sessions-teams-show-exceptions' }" class="grey--text">
                    Cancel
                </router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
import Params from "@/api/params";
import GlobalMixin from "@/mixins/global";
import Consts from "@/consts";
import DateField from '@/components/shared/DateField.vue'

export default {
    components: { DateField },
    mixins: [GlobalMixin],
    props: {
        team: {
            type: Object,
            required: true,
            default: () => { }
        }
    },
    data() {
        return {
            exception: {
                start: null,
                end: null,
                max_morning: null,
                max_afternoon: null,
                max_evening: null,
            },
            formValid: false,
            Consts
        };
    },
    computed: {
        isNew() {
            return this.$route.params.exception_id === "new";
        },
    },
    mounted() {
        if (!this.isNew) {
            this.fetch();
        }
    },
    methods: {
        fetch() {
            Params.get(
                `teams/${this.team.id}/capacity-exceptions`,
                this.$route.params.exception_id
            ).then(res => {
                this.exception = res.data;
            });
        },
        save(cont) {
            if (!this.$refs.form.validate()) {
                return;
            }

            if (this.isNew) {
                Params.create(`teams/${this.team.id}/capacity-exceptions`, this.exception).then(() => {
                    this.$snotify.success(`Exception has been created`);
                    if(cont){
                        this.$refs.form.reset()
                    } else {
                        this.$router.push({ name: "admin-sessions-teams-show-exceptions" });
                    }
                });
            } else {
                Params.update(
                    `teams/${this.team.id}/capacity-exceptions`,
                    this.exception.id,
                    this.exception
                ).then(() => {
                    this.$router.push({ name: "admin-sessions-teams-show-exceptions" });
                    this.$snotify.success(`Exception has been updated`);
                });
            }
        },
    }
};
</script>
